import axios from "axios";

const store = {
  state: {
    user: null,
    token: localStorage.getItem("access_token") || null,
  },

  getters: {
    getUser(state) {
      return state.user;
    },
  },

  mutations: {
    auth(state, data) {
      let user = {
        email: data.user.email,
        names: data.user.names,
        surnames: data.user.surnames,
      };
      state.user = data.user;
      state.token = data.token;
      localStorage.setItem("access_token", data.token);
      localStorage.setItem("user", JSON.stringify(user));
    },

    setUser(state, user) {
      state.user = user;
    },

    logout(state) {
      state.user = null;
      state.token = null;
      localStorage.removeItem("user");
      localStorage.removeItem("access_token");
    },
  },

  actions: {
    //use
    login({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/account/login`, {
            username: credentials.email,
            password: credentials.password,
            code: credentials.code,
          })
          .then((response) => {
            commit("auth", response.data);
            resolve();
          })
          .catch((error) => {
            commit("logout");
            reject(error);
          });
      });
    },

    //use
    findUserByTokenAction({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/account/find-user-by-token`)
          .then((res) => {
            commit("setUser", res.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    editUserAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/account/update/${payload.id}`, payload)
          .then((res) => {
            commit("setUser", res.data.user);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    editPasswordAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/account/update-password/${payload.id}`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    logout({ commit }) {
      commit("logout");
    },

    requestCodeAction(Context, email) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/account/request-code`, {
            email: email,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    changePwdAction(Context, password) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/account/change-password`, { password: password })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default store;
